import { useQuery } from "@tanstack/react-query"
import type { EmailLogFilter } from "@/api"
import { api } from "@/api"

export const emailKeys = {
	status: ["email", "status"] as const,
	log: (filter: EmailLogFilter) => ["email", "log", filter] as const,
	templates: ["email", "templates"] as const,
	preview: (id: string) => ["email", "preview", id] as const,
	message: (id: string) => ["email", "message", id] as const,
}

/** Статус канала: очередь и суточный бюджет меняются сами — обновляем раз в 30 с. */
export function useEmailStatus() {
	return useQuery({ queryKey: emailKeys.status, queryFn: () => api.email.status(), refetchInterval: 30_000 })
}

export function useEmailLog(filter: EmailLogFilter) {
	return useQuery({ queryKey: emailKeys.log(filter), queryFn: () => api.email.log(filter), refetchInterval: 30_000 })
}

export function useEmailTemplates() {
	return useQuery({ queryKey: emailKeys.templates, queryFn: () => api.email.templates() })
}

export function useEmailPreview(id: string | null) {
	return useQuery({
		queryKey: emailKeys.preview(id ?? ""),
		queryFn: () => api.email.preview(id ?? ""),
		enabled: Boolean(id),
	})
}

export function useEmailMessage(id: string | null) {
	return useQuery({
		queryKey: emailKeys.message(id ?? ""),
		queryFn: () => api.email.message(id ?? ""),
		enabled: Boolean(id),
	})
}
